
<template>
    <div class="services-details-area ptb-100 d-flex align-items-center justify-content-center" style="min-height: 100vh;">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12">
                    <div class="services-details-image">
                        <img src="/images/services/conscious-sedation/conscious-sedation_main.webp" alt="image">
                    </div>
                     <div class="services-details-content">
                        <u><h3>{{ $t('conscious_sedation_title') }}</h3></u>
                        <p>{{ $t('conscious_sedation_p') }}</p>
                    </div>
                    

                    <div class="services-details-content">
                        <u><h3>{{ $t('conscious_sedation_cases_title') }}</h3></u>
                        <p >{{ $t('conscious_sedation_cases_p') }}</p>
                        <p >{{ $t('conscious_sedation_cases_p1') }}</p>
                        
                    </div>


                    <div class="services-details-content">
                        <u><h3>{{ $t('conscious_sedation_guide_title') }}</h3></u>
                        <h4>{{ $t('conscious_sedation_guide_p') }}</h4>
                        <ul>
                            
                            <li>
                                <b> {{ $t('conscious_sedation_guide_li_3') }}</b>
                                <p>{{ $t('conscious_sedation_guide_p_3') }}</p>
                            </li>
                        </ul>
                    </div>
                    <div class="services-details-content">
                        <h3>{{ $t('conscious_sedation_guide_after_title') }}</h3>
                        <ul>
                            <li>
                                {{ $t('conscious_sedation_guide_after_p1') }}
                            </li>
                            <li>
                                {{ $t('conscious_sedation_guide_after_p2') }}
                            </li>
                            <li>
                                {{ $t('conscious_sedation_guide_after_p3') }}
                            </li>
                            <li>
                                {{ $t('conscious_sedation_guide_after_p4') }}
                            </li>
                        </ul>
                        <p>{{ $t('conscious_sedation_guide_after_p') }}</p>
                    </div>


                </div>

                </div>
            </div>
        </div>
    
</template>


<script>


    export default {
        name: 'ConsciousSedation',
    };
    
</script>


